import { Heading } from "@/shared-web.ui/ui.heading";
import { cn } from "@/shared-web.ui/util.cn";

interface SectionTitleProps extends React.HTMLAttributes<HTMLDivElement> {}
const SectionTitle = (props: SectionTitleProps) => {
  const { className, children, ...rest } = props;
  return (
    <div
      {...rest}
      className={cn("flex justify-center", className)}
    >
      <Heading
        size="6"
        weight="medium"
        as="h2"
      >
        {children}
      </Heading>
    </div>
  );
};

export {
  SectionTitle,
};
